import { createSelector } from '@reduxjs/toolkit';
import omit from 'lodash.omit';

import {
  DataSourceType,
  TypeDescriptionCombinedOption,
} from 'src/constants/dataSourceTypeDescription';
import { dataSourceTypeDescriptionSelector } from 'src/selectors/dataSourceTypeDescription';
import { Connection } from 'src/store/connections/types';

export const virtualGraphPropertiesSelector = (
  connection: Connection | null,
  type: DataSourceType | null
) =>
  createSelector(
    dataSourceTypeDescriptionSelector(connection),
    (typeDescription) => {
      const familyOptions =
        type === null
          ? {}
          : typeDescription.DATA_SOURCE_FAMILIES[
              typeDescription.DATA_SOURCE_TYPES[type].dataSourceFamily
            ].VIRTUAL_GRAPH_OPTIONS;
      const allProperties = new Set<string>([
        ...Object.keys(omit(familyOptions, 'base')),
      ]);
      return Array.from(allProperties).reduce<
        Partial<Record<DataSourceType, TypeDescriptionCombinedOption>>
      >(
        (agg, property) => ({
          ...agg,
          [property]: {
            ...(typeDescription.VIRTUAL_GRAPH_OPTIONS.base || {}),
            ...(typeDescription.VIRTUAL_GRAPH_OPTIONS[property] || {}),
            ...(familyOptions.base || {}),
            ...(familyOptions[property] || {}),
          },
        }),
        {}
      );
    }
  );
